import { isNullOrUndefined, isString } from 'util';
import React from 'react';
import { FormattedNumber } from 'react-intl';

export function NullableFormattedNumber(props: { value?: string | undefined | null | number }) {
    if (isNullOrUndefined(props.value)) {
        return null;
    }
    const numberValue = isString(props.value) ? parseFloat(props.value) : props.value;
    return <FormattedNumber value={numberValue} />;
}
